<template>
  <div class="w-full h-full">
    <!-- Perhaps some inspirational text here that appeals to the user - a product manager - to be better at their job -->
     
    <!-- <div class="flex flex-col items-center justify-center h-full p-3 opacity-75">
      <div class="max-w-2xl text-left">
        <p class="text-xl leading-relaxed italic mb-6">"SupaPM has transformed how we manage our product roadmap. The AI-powered insights have helped us make better decisions and stay ahead of market trends."</p>
        <div class="flex flex-col items-start">
          <p class="font-semibold">Sarah Chen</p>
          <p class="text-sm text-gray-500">Head of Product at <a href="https://techflowsolutions.com" target="_blank" class="text-blue-500">TechFlow Solutions</a></p>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script setup>
definePageMeta({
  layout: 'webapp',
  middleware: ['auth']
})
</script>